import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useSunbitEnroll = (clientId, options = {}) => {
  const res = useMutation(
    (dto) => http.post(HTTP_ENDPOINTS.sunbit.enrollPatient(clientId), dto),
    {
      ...options,
    },
  );
  return res;
};
